/*
 * 封装 axios
 */
import axios from "axios";

// import { loading } from 'element-ui' //引入提示

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.withCredentials = true

// 创建 实例 axios  对象
const instance = axios.create({
  baseURL: "/api", //baseUrl
  // timeout: 60000,
  timeout: 300000,
});

//请求拦截
instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

//请求响应拦截
instance.interceptors.response.use(
  (res) => {
    // console.log(res);
    return res.data;
  },
  (error) => {
    // console.log(error);
    // const stats = error.data.code;
    return error;
  }
);

// get 请求
export function get(url, params) {
  return instance.get(url, { params });
}

//post 请求
export function post(url, data) {
  return instance.post(url, data);
}

export default instance;
